class G2ILLTheme {
  constructor(root = document) {
    this.root = root;
    this.bindMobileMenu();
    this.bindCartDrawer();
    this.bindQuantity();
    this.bindVariantForms();
  }
  bindMobileMenu() {
    const menu = document.querySelector('[data-mobile-menu]');
    const open = document.querySelector('[data-mobile-menu-open]');
    const close = document.querySelector('[data-mobile-menu-close]');
    if (!menu || !open) return;
    const set = (shown) => {
      menu.setAttribute('aria-hidden', String(!shown));
      open.setAttribute('aria-expanded', String(shown));
      document.body.classList.toggle('drawer-open', shown);
      if (shown) close?.focus();
    };
    open.addEventListener('click', () => set(true));
    close?.addEventListener('click', () => set(false));
    menu.addEventListener('click', (event) => { if (event.target === menu) set(false); });
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape') set(false); });
  }
  bindCartDrawer() {
    const drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;
    const openers = document.querySelectorAll('[data-cart-open]');
    const closers = drawer.querySelectorAll('[data-cart-close]');
    const set = (shown) => {
      drawer.setAttribute('aria-hidden', String(!shown));
      document.body.classList.toggle('drawer-open', shown);
      if (shown) drawer.querySelector('[data-cart-close]')?.focus();
    };
    openers.forEach((button) => button.addEventListener('click', () => set(true)));
    closers.forEach((button) => button.addEventListener('click', () => set(false)));
    drawer.addEventListener('click', (event) => { if (event.target.matches('[data-cart-overlay]')) set(false); });
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape') set(false); });
  }
  bindQuantity() {
    document.querySelectorAll('[data-quantity]').forEach((wrap) => {
      const input = wrap.querySelector('input');
      wrap.querySelectorAll('button').forEach((button) => {
        button.addEventListener('click', () => {
          const step = Number(button.dataset.step || 0);
          input.value = Math.max(Number(input.min || 1), Number(input.value || 1) + step);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }
  bindVariantForms() {
    document.querySelectorAll('[data-product-form]').forEach((form) => {
      const dataScript = form.querySelector('[data-variant-json]');
      if (!dataScript) return;
      const variants = JSON.parse(dataScript.textContent);
      const idInput = form.querySelector('[name="id"]');
      const price = form.querySelector('[data-product-price]');
      const compare = form.querySelector('[data-compare-price]');
      const submit = form.querySelector('[type="submit"]');
      const optionInputs = form.querySelectorAll('[data-option-input]');
      const moneyFormat = form.dataset.moneyFormat || '$' + '{{amount}}';
      const formatMoney = (cents) => moneyFormat.replace('{{amount}}', (cents / 100).toFixed(2)).replace('{{ amount }}', (cents / 100).toFixed(2));
      const update = () => {
        const selected = Array.from(optionInputs).filter((input) => input.checked || input.tagName === 'SELECT').map((input) => input.value);
        const variant = variants.find((item) => item.options.every((value, index) => value === selected[index]));
        if (!variant) return;
        idInput.value = variant.id;
        if (price) price.textContent = formatMoney(variant.price);
        if (compare) {
          compare.textContent = variant.compare_at_price && variant.compare_at_price > variant.price ? formatMoney(variant.compare_at_price) : '';
        }
        if (submit) {
          submit.disabled = !variant.available;
          submit.textContent = variant.available ? submit.dataset.addText : submit.dataset.soldText;
        }
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      };
      optionInputs.forEach((input) => input.addEventListener('change', update));
      update();
    });
  }
}
document.addEventListener('DOMContentLoaded', () => new G2ILLTheme());
document.addEventListener('shopify:section:load', () => new G2ILLTheme());
